module.exports = __webpack_public_path__ + "img/p3.91a6ec46.png";